import { AluuOrders } from '@apis/index'
import { outlinestore } from '@assets/icons'
import Column from '@components/column'
import { StatusTag } from '@components/status/style'
import Table from '@components/table'
import Title from '@components/title'
import { RootState } from '@store/index'
import { Helper } from '@utils/index'
import React, { Fragment, useState } from 'react'
import { useSelector } from 'react-redux'

const GameTopUpOrderHistory = () => {
  const {
    items: orders,
    totalItems,
    totalPages,
    loading,
  } = useSelector((state: RootState) => state.aluuOrders)
  const [page, setPage] = useState(1)
  const [searchTerm, setSearchTerm] = useState('')

  const data = orders.map((order) => ({
    id: order.id,
    userName: order.user?.name ?? '-',
    userEmail: order.user?.email ?? '-',
    gameName: order.gameName ?? order.gameCode,
    productName: order.productName ?? order.denom,
    gameUserId: order.gameUserId,
    serverId: order.serverId ?? '-',
    charName: order.charName ?? '-',
    amount: order.amount,
    status: order.status,
    createdAt: order.createdAt ? order.createdAt.split('T')[0] : '-',
  }))

  const columns = [
    {
      title: 'User',
      key: 'user',
      render: (item) => (
        <Column stylecolumn="row-gap:2px">
          <p>{item.userName}</p>
          <p style={{ color: 'gray', fontSize: '12px' }}>{item.userEmail}</p>
        </Column>
      ),
    },
    { title: 'Game', key: 'gameName' },
    { title: 'Product', key: 'productName' },
    { title: 'Game User ID', key: 'gameUserId' },
    { title: 'Server ID', key: 'serverId' },
    { title: 'Character', key: 'charName' },
    { title: 'Amount', key: 'amount' },
    {
      title: 'Status',
      key: 'status',
      render: (item) => {
        const { text, bg } = Helper.getStatusColor(item.status)
        return (
          <StatusTag textColor={text} bgColor={bg}>
            {item.status}
          </StatusTag>
        )
      },
    },
    { title: 'Date', key: 'createdAt' },
  ]

  const fetchOrders = async (search = '') => {
    try {
      await AluuOrders.list({
        state: 'aluuOrders',
        params: {
          page,
          limit: 30,
          ...(search && { search }),
        },
      })
    } catch (error) {
      console.error(error)
    }
  }

  React.useEffect(() => {
    setPage(1)
  }, [searchTerm])

  React.useEffect(() => {
    fetchOrders(searchTerm)
  }, [page, searchTerm])

  return (
    <Fragment>
      <Column>
        <Title textone="Store Management >" texttwo="Game Top-Up Order History" />
        <Table
          onSearchChange={setSearchTerm}
          loading={loading}
          onPageChange={setPage}
          totalItems={totalItems}
          totalPages={totalPages}
          pageControlled={page}
          itemsPerPage={30}
          data={data}
          columns={columns}
          searchKeys={['userName', 'userEmail', 'gameName', 'productName']}
          text="Game top-up order history"
          icon={outlinestore}
          actions={[
            {
              key: 'track',
              icon: outlinestore,
              onClick: async (item) =>
                await AluuOrders.track({ id: item.id, state: 'aluuOrders' }),
            },
          ]}
        />
      </Column>
    </Fragment>
  )
}

export default GameTopUpOrderHistory
